import React from 'react';
import { FormikProps } from 'formik';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { CoveragePlans, DeclinedValue, PlanTypes, TierMessage } from '../../enrollment/models/coverage-models';
import { getRateByCodeAndTier } from '../../enrollment/helpers/coverage-display-helpers';
import { getCurrencyFormat } from '../../../../../../global/helpers/format-helpers';
import { CalculatedTiers } from '../../models/new-hire-enrollment-models';
import { AETiers } from '../../../../../annual-enrollment/models/annual-enrollment-models';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { getLetterMonthDate } from '../../../../../../global/helpers/date-helpers';
import { replaceAll } from '../../../../../../global/helpers/string-helpers';
import { MemberEnrolledCoverage } from '../models/member-coverage-model';

interface Props {
	planType: PlanTypes;
	groupLabel: string;
	plan: CoveragePlans;
	completedPlan: MemberEnrolledCoverage;
	formValues: FormikProps<any>;
	tier: CalculatedTiers;
	settings: NewHireProps;
	declinedMessage: string;
}
export function MemberMedicalDentalPlanDisplay(props: Props) {

	const { planType, groupLabel, plan, formValues, tier, settings, completedPlan, declinedMessage } = props;

	function getTierLabel(currentTier: string) {
		switch (currentTier) {
			case AETiers.Family:
				return TierMessage.F;
			case AETiers.EmpPlusOne:
				return TierMessage.T;
			case AETiers.Single:
				return TierMessage.I;
			case AETiers.EmpPlusChild:
				return TierMessage.G;
			case AETiers.EmpPlusMulti:
				return TierMessage.D;
			default:
				return TierMessage.N;
		}
	}

	function RenderPlanName() {

		if ((!plan?.plans || plan?.plans?.length <= 0) && !completedPlan?.plan?.name) return null;

		const planCode = planType && formValues?.values[planType];
		const planName = completedPlan?.plan?.name || plan?.plans?.find(item => item?.code === planCode)?.name;
		return (<h4> {planName} </h4>);
	}

	function RenderRate() {

		if ((!plan?.plans || plan?.plans?.length <= 0) && !completedPlan?.plan?.name) return null;
		const planCode = planType && formValues?.values[planType];
		const planAmount = getRateByCodeAndTier(plan?.plans, planCode, tier?.selected_tier);

		return (
			<div className='form-item'>
				<p><strong>{getTierLabel(completedPlan?.plan?.tier || tier?.selected_tier)}</strong></p>
				<p>{getCurrencyFormat(completedPlan?.plan?.rate || planAmount)}</p>
			</div>
		);
	}

	function RenderEffectiveDate() {
		if (!plan?.effective_date && !completedPlan?.plan?.name) return null;

		return (
			<div className='form-item'>
				<p><strong>{settings?.effectiveDateLabel}</strong></p>
				<p>{getLetterMonthDate(replaceAll(completedPlan?.effective_date || plan?.effective_date, '-', '/'))}</p>
			</div>
		);
	}

	if (!plan && !completedPlan?.plan?.name) return null;	// no plan selected

	return (
		<DividerSection sectionText={groupLabel} removeDivider >
			<ContentSpacer>
				{
					(plan && (!formValues?.values[planType] || formValues?.values[planType] === DeclinedValue ))
						? <p>{declinedMessage}</p>
						: <div className='grid-main-content'>
							{RenderPlanName()}
							{RenderRate()}
							{RenderEffectiveDate()}
						</div>
				}
			</ContentSpacer>
		</DividerSection>
	);
}
